import { Icon } from "@iconify/react";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import Accordion from "../Common/Accordion";

const ObjectAttribute = (props) => {
    const [editButtonHover, setEditButtonHover] = useState(true);
    const [addButtonHover, setAddButtonHover] = useState(true);
    const [fieldEditable, setFieldEditable] = useState(false);

    if (props.type === 'key') {
        return (
            <th
                style={{ verticalAlign: 'top' }}
                onMouseEnter={() => {
                    setAddButtonHover(false);
                    setEditButtonHover(false)
                }}
                onMouseLeave={() => {
                    setAddButtonHover(true);
                    setEditButtonHover(true)
                }}
            >
                {
                    fieldEditable &&
                    <>
                        <input className="mr-2" name={props.data} value={props.data} />
                        <Icon
                            className="pr-1 cursor-pointer"
                            color={`${editButtonHover ? '#00000000' : '#075978b8'}`}
                            icon={`ri:save-3-fill`}
                            height='25px' />
                        <Icon
                            onClick={() => setFieldEditable(false)}
                            className="pr-1 cursor-pointer"
                            color={`${editButtonHover ? '#00000000' : '#075978b8'}`}
                            icon={`ri:close-fill`}
                            height='25px' />
                    </>
                }
                {
                    !fieldEditable &&
                    <>
                        <span style={{ color: '#a31515', fontWeight: 'normal' }}>{props.data}</span>
                        <Icon
                            onClick={() => setFieldEditable(true)}
                            className={props.className}
                            color={`${editButtonHover ? '#00000000' : '#075978b8'}`}
                            icon={`ri:edit-2-fill`}
                            height='20px' />
                        <Icon
                            style={props.style}
                            className={props.className}
                            color={`${addButtonHover ? '#00000000' : '#137012ad'}`}
                            icon={`ri:add-box-fill`}
                            height='20px' />
                    </>
                }
            </th>
        )
    } else {
        return (
            <td>
                <Accordion
                    display={true}
                    title={createAccordionTitle(props.data, props.attribute)}
                    content={() => {
                        return (
                            <table className="table table-bordered">
                                {
                                    <TableHeadingContent data={props.data} />
                                }
                            </table>
                        )
                    }}
                />
            </td>
        )
    }
}

const NonObjectAttribute = (props) => {

    const [editButtonHover, setEditButtonHover] = useState(true);
    const [fieldEditable, setFieldEditable] = useState(false);

    if (props.type === 'key') {
        return (
            <th
                onMouseEnter={() => setEditButtonHover(false)}
                onMouseLeave={() => setEditButtonHover(true)}
            >
                {
                    fieldEditable &&
                    <>
                        <input className="mr-2" name={props.data} value={props.data} />
                        <Icon
                            className={props.className}
                            color={`${editButtonHover ? '#00000000' : '#075978b8'}`}
                            icon={`ri:save-3-fill`}
                            height='25px' />
                        <Icon
                            onClick={() => setFieldEditable(false)}
                            className={props.className}
                            color={`${editButtonHover ? '#00000000' : '#075978b8'}`}
                            icon={`ri:close-fill`}
                            height='25px' />
                    </>
                }
                {
                    !fieldEditable &&
                    <>
                        <span
                            style={{ color: '#a31515', fontWeight: 'normal', fontFamily: '"Droid Sans Mono", "monospace", monospace' }}
                        >
                            {props.data}
                        </span>
                        <Icon
                            onClick={() => setFieldEditable(true)}
                            className={props.className}
                            color={`${editButtonHover ? '#00000000' : '#075978b8'}`}
                            icon={`ri:edit-2-fill`}
                            height='20px' />
                    </>
                }
            </th>
        )
    } else {
        return (
            <td
                onMouseEnter={() => setEditButtonHover(false)}
                onMouseLeave={() => setEditButtonHover(true)}
            >
                {
                    fieldEditable &&
                    <>
                        <input className="mr-2" name={props.data} value={props.data} />
                        <Icon
                            className={props.className}
                            color={`${editButtonHover ? '#00000000' : '#075978b8'}`}
                            icon={`ri:save-3-fill`}
                            height='25px' />
                        <Icon
                            onClick={() => setFieldEditable(false)}
                            className={props.className}
                            color={`${editButtonHover ? '#00000000' : '#075978b8'}`}
                            icon={`ri:close-fill`}
                            height='25px' />
                    </>
                }
                {
                    !fieldEditable &&
                    <>
                        <span
                            style={{ color: `${typeof props.data === 'string' ? '#0451a5' : '#098658'}`, fontWeight: 'normal', fontFamily: '"Droid Sans Mono", "monospace", monospace' }}
                        >
                            {props.data}
                        </span>
                        <Icon
                            onClick={() => setFieldEditable(true)}
                            className={props.className}
                            color={`${editButtonHover ? '#00000000' : '#075978b8'}`}
                            icon={`ri:edit-2-fill`}
                            height='20px' />
                    </>
                }
            </td>
        )
    }
}


const TableHeadingContent = (props) => {

    let keys;
    if (!_.isEmpty(props.data)) {
        keys = Object.keys(props.data);
        return keys.length > 0 && keys.map((key, index) => {

            if (typeof props.data[key] !== 'object') {
                return (
                    <thead id={`data-level-${index}`}>
                        <tr>
                            <NonObjectAttribute
                                className='mr-1 ml-1 cursor-pointer'
                                type='key'
                                data={key}
                            />
                            <NonObjectAttribute
                                className='mr-1 ml-1 cursor-pointer'
                                type='value'
                                data={props.data[key]}
                            />
                        </tr>
                    </thead>
                )
            } else {
                return (
                    <thead id={`data-level-${index}`}>
                        <tr>
                            <ObjectAttribute
                                className='mr-1 ml-1 cursor-pointer'
                                type='key'
                                data={key}
                            />
                            <ObjectAttribute
                                className='mr-1 ml-1 cursor-pointer'
                                type='value'
                                data={props.data[key]}
                                attribute={key}
                            />
                        </tr>
                    </thead>
                )
            }
        })
    } else {
        return null;
    }
}

const createAccordionTitle = (data, key) => {
    if (data) {
        let type = typeof data;
        switch (type) {
            case 'object':
                if (Array.isArray(data)) {
                    return <b>{`${key} - Array[${data.length}]`}</b>;
                }
                return <b>{`${key} - Object[${Object.keys(data).length}]`}</b>;
            case 'string':
                return <b>{`${key} - String`}</b>;
            case 'number':
                return <b>{`${key} - Number`}</b>;
            case 'boolean':
                return <b>{`${key} - Boolean`}</b>;
            default:
                return <b>{`${key}`}</b>
        }
    }
}

const JsonPreviewComponent = (props) => {

    const [data, setData] = useState({});

    useEffect(() => {
        if (!_.isEmpty(props.data)) {
            setData(props.data);
        }
    }, [props.data]);

    return (
        <div style={{ height: props.height, overflowY: "auto", overflowX: "auto" }}>
            <table className="table table-bordered text-left">
                {
                    data && typeof data === 'object' &&
                    <TableHeadingContent data={data} />
                }
            </table>
        </div>
    )

}

export default JsonPreviewComponent;